import { useState, useEffect } from "react";
import { http } from "../api";
import { Sparkles, Target, GraduationCap, Rocket, MessageSquareWarning, Quote, LogIn, Send, X, ArrowRight, Globe, Heart, BookOpen, Clock, CheckCircle2, MessageCircle, EyeOff, Eye } from "lucide-react";

// Bilingual copy strip — Bengali default with English toggle
const COPY = {
  bn: {
    nav_home: "হোম", nav_programs: "প্রোগ্রাম", nav_advice: "পরামর্শ", nav_complaint: "অভিযোগ", nav_contact: "যোগাযোগ", nav_pricing: "প্রাইসিং",
    login: "লগইন", open_crm: "সিআরএম খুলুন", register: "যোগ দিন",
    hero_tagline: "সমস্যা সমাধানের মন, উদ্যোগের যাত্রা।",
    hero_title: "বিনামূল্যে ক্যারিয়ার নির্দেশনা।",
    hero_sub: "ছাত্রছাত্রী, দক্ষ ব্যক্তি ও উদ্যোক্তাদের সাফল্যের পথে এগিয়ে দিতে আমাদের প্রয়াস। ওয়ার্ড ৭-এর জন্য, ওয়ার্ড ৭-এর দ্বারা।",
    cta_join: "বিনামূল্যে যোগ দিন",
    cta_complaint: "সরকারি অভিযোগ জানান",
    mission_eyebrow: "আমাদের মিশন",
    mission_title: "উন্নয়ন — মানুষের হাত ধরে।",
    mission_body: "ওয়ার্ড ৭ নবদ্বীপের প্রতিটি পরিবারকে সাহায্য করা, সমস্যার সমাধান দেওয়া এবং তরুণ প্রজন্মকে দক্ষতার সঙ্গে গড়ে তোলা — এই তিনটি স্তম্ভের উপরে আমরা দাঁড়িয়ে আছি।",
    programs_eyebrow: "প্রোগ্রাম",
    programs_title: "চার ধাপের সাফল্য যাত্রা",
    p1_title: "ছাত্র মেন্টরশিপ", p1_body: "ক্লাস ৯ থেকে কলেজ পর্যন্ত — ফ্রি টিউশন, বৃত্তির খবর, পরীক্ষার প্রস্তুতি।",
    p2_title: "দক্ষতা প্রশিক্ষণ", p2_body: "সিলাই, টেলারিং, IT বেসিক, স্পোকেন ইংলিশ — প্রশিক্ষণ সরকারি স্বীকৃতিসহ।",
    p3_title: "উদ্যোক্তা শুরু", p3_body: "ছোট ব্যবসার জন্য মেন্টর, ঋণের যোগাযোগ, বাজারের সন্ধান।",
    p4_title: "সমস্যা সমাধান কর্মশালা", p4_body: "মাসিক সেশন — নেতৃত্ব, সমস্যা সমাধানের মন, সিদ্ধান্ত গ্রহণ।",
    complaint_eyebrow: "জনসাধারণের অভিযোগ",
    complaint_title: "একটি অভিযোগ জানান — আমরা দায়িত্ব নেব।",
    complaint_sub: "লগইন করে অভিযোগ জমা দিন, সংশ্লিষ্ট বুথ-দায়িত্বপ্রাপ্ত সদস্য অবিলম্বে অবগত হবেন। ৩০ মিনিটের মধ্যে অ্যাকনলেজ না হলে সুপার অ্যাডমিন-কে জানানো হবে।",
    complaint_title_lbl: "শিরোনাম", complaint_desc_lbl: "বিবরণ", complaint_booth_lbl: "বুথ (যদি জানেন)",
    complaint_send: "অভিযোগ পাঠান",
    testi_eyebrow: "মতামত",
    testi_title: "যাঁরা এগিয়ে এসেছেন",
    testimonials: [
      { name: "সঞ্জয় দাস", role: "ছাত্র · ক্লাস ১২", quote: "মেন্টরশিপ প্রোগ্রাম আমার JEE প্রস্তুতিতে অনেক সাহায্য করেছে।" },
      { name: "রিয়া কর্মকার", role: "উদ্যোক্তা", quote: "নিজের বিউটি পার্লার খুলেছি — লোন যোগাযোগে টিম ৭-এর সাহায্য ছিল দারুণ।" },
      { name: "প্রশান্ত ব্যানার্জী", role: "স্থানীয় বাসিন্দা", quote: "পানি জমার সমস্যা এক দিনেই সমাধান হয়েছিল। ধন্যবাদ ওয়ার্ড ৭ দল।" },
    ],
    contact_eyebrow: "যোগাযোগ",
    contact_title: "আজই যুক্ত হোন",
    contact_sub: "আমরা ২৪ ঘণ্টার মধ্যে যোগাযোগ করব।",
    footer: "© ২০২৬ ওয়ার্ড ৭ · নবদ্বীপ · সুরজিৎ বিশ্বাস দ্বারা পরিচালিত",
    advice_eyebrow: "পরামর্শ ব্লগ", advice_title: "মেন্টরদের কাছ থেকে ক্যারিয়ার টিপস", advice_none: "শীঘ্রই আসছে…",
    advice_read: "পড়ুন", advice_like: "লাইক", advice_liked: "লাইকড",
    cat_all: "সব", cat_student: "ছাত্র", cat_career: "কেরিয়ার", cat_exam: "পরীক্ষা", cat_entrepreneur: "উদ্যোক্তা",
    comments_title: "মন্তব্য", comments_none: "প্রথম মন্তব্য করুন…", comment_placeholder: "সংক্ষেপে আপনার মতামত লিখুন…",
    comment_send: "পাঠান", comment_login_prompt: "মন্তব্য করার জন্য লগইন করুন", comment_hidden: "লুকানো", comment_hide: "লুকান", comment_unhide: "প্রকাশ করুন",
    my_complaints_eyebrow: "আমার অভিযোগ", my_complaints_title: "আপনার অভিযোগের অগ্রগতি", my_complaints_none: "এখনও কোনো অভিযোগ জমা দেননি।",
    login_title: "ফিরে স্বাগতম",
    register_title: "একটি নতুন অ্যাকাউন্ট তৈরি করুন",
    email: "ইমেইল", password: "পাসওয়ার্ড", name_lbl: "নাম", mobile_lbl: "মোবাইল",
    submit_login: "লগইন করুন", submit_register: "যোগ দিন",
    have_account: "আগেই যোগ দিয়েছেন?", no_account: "নতুন?",
    logged_in_as: "লগইন:",
    logout: "লগ আউট",
  },
  en: {
    nav_home: "Home", nav_programs: "Programs", nav_advice: "Advice", nav_complaint: "Complaint", nav_contact: "Contact", nav_pricing: "Pricing",
    login: "Log in", open_crm: "Open CRM", register: "Join free",
    hero_tagline: "Problem-solving minds. Entrepreneurial hearts.",
    hero_title: "Career guidance, absolutely free.",
    hero_sub: "We help students, skilled individuals and entrepreneurs move from ambition to achievement. For Ward 7. By Ward 7.",
    cta_join: "Join free",
    cta_complaint: "Lodge a public complaint",
    mission_eyebrow: "Our mission",
    mission_title: "Development, hand-in-hand.",
    mission_body: "Support every family in Ward 7 Nabadwip, solve problems as they come, and raise a skilled next generation. Three pillars. One promise.",
    programs_eyebrow: "Programs",
    programs_title: "A four-step journey to success",
    p1_title: "Student mentorship", p1_body: "Class 9 through college — free tutoring, scholarship info, exam prep.",
    p2_title: "Skill training", p2_body: "Tailoring, IT basics, spoken English — certified courses recognised by the government.",
    p3_title: "Entrepreneurship launch", p3_body: "Business mentors, loan connections, and market linkages for micro-enterprises.",
    p4_title: "Problem-solving lab", p4_body: "Monthly sessions on leadership, structured thinking, decision-making.",
    complaint_eyebrow: "Public complaints",
    complaint_title: "Raise an issue — we'll take responsibility.",
    complaint_sub: "Log in and lodge it. The booth-responsible member gets alerted instantly. Unacknowledged in 30 min? Super Admin steps in.",
    complaint_title_lbl: "Title", complaint_desc_lbl: "Describe the issue", complaint_booth_lbl: "Booth (if you know)",
    complaint_send: "Send complaint",
    testi_eyebrow: "Voices from Ward 7",
    testi_title: "People who moved ahead",
    testimonials: [
      { name: "Sanjay Das", role: "Class 12 · Student", quote: "The mentorship helped me crack JEE prep like nothing else did." },
      { name: "Riya Karmakar", role: "Entrepreneur", quote: "Opened my beauty parlour — the team's loan-linking support was fantastic." },
      { name: "Prashanto Banerjee", role: "Resident", quote: "Waterlogging outside my house was fixed in a single day. Thank you, Ward 7 team." },
    ],
    contact_eyebrow: "Contact",
    contact_title: "Get in touch today",
    contact_sub: "We'll reach out within 24 hours.",
    footer: "© 2026 Ward 7 · Nabadwip · Curated by Surajit Biswas",
    advice_eyebrow: "Advice Blog", advice_title: "Career tips from mentors", advice_none: "Coming soon…",
    advice_read: "Read", advice_like: "Like", advice_liked: "Liked",
    cat_all: "All", cat_student: "Student", cat_career: "Career", cat_exam: "Exam", cat_entrepreneur: "Entrepreneur",
    comments_title: "Comments", comments_none: "Be the first to comment…", comment_placeholder: "Share a short thought…",
    comment_send: "Post", comment_login_prompt: "Log in to comment", comment_hidden: "Hidden", comment_hide: "Hide", comment_unhide: "Unhide",
    my_complaints_eyebrow: "My complaints", my_complaints_title: "Track your complaints", my_complaints_none: "You haven't lodged any complaints yet.",
    login_title: "Welcome back",
    register_title: "Create a new account",
    email: "Email", password: "Password", name_lbl: "Name", mobile_lbl: "Mobile",
    submit_login: "Log in", submit_register: "Join free",
    have_account: "Already joined?", no_account: "New here?",
    logged_in_as: "Signed in as",
    logout: "Log out",
  },
};

export default function Landing({ user, onLogin }) {
  const [lang, setLang] = useState(() => localStorage.getItem("landing_lang") || "bn");
  const t = COPY[lang];
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("register"); // register | login
  const [authForm, setAuthForm] = useState({ name: "", email: "", mobile: "", password: "" });
  const [authBusy, setAuthBusy] = useState(false);
  const [authErr, setAuthErr] = useState("");

  const [complaintOpen, setComplaintOpen] = useState(false);
  const [complaintForm, setComplaintForm] = useState({ title: "", description: "", booth: "" });
  const [complaintBusy, setComplaintBusy] = useState(false);
  const [complaintResult, setComplaintResult] = useState(null);
  const [advice, setAdvice] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [readingPost, setReadingPost] = useState(null);
  const [brand, setBrand] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [commentBusy, setCommentBusy] = useState(false);
  const [myComplaints, setMyComplaints] = useState([]);

  useEffect(() => { localStorage.setItem("landing_lang", lang); }, [lang]);
  useEffect(() => { http.get("/public/advice").then((r) => setAdvice(r.data.posts || [])).catch(() => {}); }, []);
  useEffect(() => {
    // Deep-link support: /#register or /#login (used from Pricing "Get started")
    const h = (window.location.hash || "").replace("#", "").toLowerCase();
    if (h === "register" || h === "login") {
      setAuthMode(h); setAuthErr(""); setAuthOpen(true);
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);
  useEffect(() => {
    http.get("/branding/effective").then((r) => {
      const b = r.data || {};
      setBrand(b);
      const root = document.documentElement;
      if (b.primary_color) root.style.setProperty("--teal", b.primary_color);
      if (b.accent_color) root.style.setProperty("--amber", b.accent_color);
    }).catch(() => {});
  }, []);
  useEffect(() => {
    if (user && (user.role === "Public" || user.role === "Admin" || user.role === "Super Admin" || user.role === "Member")) {
      http.get("/public/my-complaints").then((r) => setMyComplaints(r.data.complaints || [])).catch(() => {});
    }
  }, [user, complaintResult]);

  const loadComments = async (postId) => {
    if (!postId) return;
    const isSuper = user?.role === "Super Admin";
    try {
      const url = isSuper ? `/advice/${postId}/comments/all` : `/public/advice/${postId}/comments`;
      const r = await http.get(url);
      setComments(r.data.comments || []);
    } catch { setComments([]); }
  };

  useEffect(() => {
    if (readingPost?.post_id) {
      loadComments(readingPost.post_id);
      // If the current user is the author, auto-ack their comment alerts for this post
      if (user && readingPost.author_id === user.user_id) {
        http.post(`/advice/${readingPost.post_id}/ack-comments`).catch(() => {});
      }
    } else {
      setComments([]); setCommentText("");
    }
  }, [readingPost?.post_id, user?.user_id]);

  const submitComment = async (e) => {
    e.preventDefault();
    if (!user) { openAuth("register"); return; }
    const text = commentText.trim();
    if (!text || text.length > 280) return;
    setCommentBusy(true);
    try {
      await http.post(`/public/advice/${readingPost.post_id}/comments`, { text, language: lang });
      setCommentText("");
      await loadComments(readingPost.post_id);
    } catch (err) {
      window.alert(err.response?.data?.detail || "Failed");
    } finally { setCommentBusy(false); }
  };

  const toggleHideComment = async (c) => {
    try {
      const url = c.hidden ? `/advice/comments/${c.comment_id}/unhide` : `/advice/comments/${c.comment_id}/hide`;
      await http.post(url);
      await loadComments(readingPost.post_id);
    } catch (err) { window.alert(err.response?.data?.detail || "Failed"); }
  };

  const react = async (post) => {
    if (!user) { openAuth("register"); return; }
    try {
      const r = post.my_reaction
        ? await http.delete(`/public/advice/${post.post_id}/react`)
        : await http.post(`/public/advice/${post.post_id}/react`);
      setAdvice((cur) => cur.map((p) => p.post_id === post.post_id ? { ...p, reactions: r.data.reactions, my_reaction: r.data.my_reaction } : p));
      if (readingPost && readingPost.post_id === post.post_id) {
        setReadingPost({ ...readingPost, reactions: r.data.reactions, my_reaction: r.data.my_reaction });
      }
    } catch (e) { window.alert(e.response?.data?.detail || "Failed"); }
  };

  const openCrm = () => { window.location.href = "/app"; };
  const openAuth = (mode) => { setAuthMode(mode); setAuthErr(""); setAuthOpen(true); };
  const closeAuth = () => { setAuthOpen(false); setAuthForm({ name: "", email: "", mobile: "", password: "" }); };

  const submitAuth = async (e) => {
    e.preventDefault(); setAuthBusy(true); setAuthErr("");
    try {
      const url = authMode === "register" ? "/public/auth/register" : "/public/auth/login";
      const r = await http.post(url, authForm);
      onLogin?.(r.data);
      closeAuth();
    } catch (err) {
      setAuthErr(err.response?.data?.detail || (lang === "bn" ? "কিছু ভুল হয়েছে" : "Something went wrong"));
    } finally { setAuthBusy(false); }
  };

  const lodgeComplaint = async (e) => {
    e.preventDefault(); setComplaintBusy(true);
    try {
      const r = await http.post("/public/complaints", complaintForm);
      setComplaintResult(r.data);
      setComplaintForm({ title: "", description: "", booth: "" });
    } catch (err) {
      window.alert(err.response?.data?.detail || "Failed");
    } finally { setComplaintBusy(false); }
  };

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch { /* noop */ }
    onLogin?.(false);
  };

  const isStaff = user && (user.role === "Super Admin" || user.role === "Admin" || user.role === "Member");

  return (
    <div className="lp" data-testid="landing-root" lang={lang}>
      <header className="lp-nav" data-testid="lp-nav">
        <div className="lp-brand" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          {brand?.logo_url ? (
            <span className="lp-mark"><img src={brand.logo_url} alt="" style={{ width: 22, height: 22, objectFit: "contain" }} /></span>
          ) : (
            <span className="lp-mark">৭</span>
          )}
          <div>
            <b>{brand?.brand_name || "Ward 7"}</b>
            <small>{(lang === "bn" ? brand?.brand_tagline_bn : brand?.brand_tagline_en) || (brand?.brand_tagline_en) || "Nabadwip · নবদ্বীপ"}</small>
          </div>
        </div>
        <nav className="lp-nav-links">
          <a href="#programs">{t.nav_programs}</a>
          <a href="#advice">{t.nav_advice}</a>
          <a href="#complaint">{t.nav_complaint}</a>
          <a href="/pricing" data-testid="lp-nav-pricing">{t.nav_pricing}</a>
          <a href="#contact">{t.nav_contact}</a>
        </nav>
        <div className="lp-nav-cta">
          <button className="lp-lang-toggle" data-testid="lp-lang-toggle" onClick={() => setLang(lang === "bn" ? "en" : "bn")}>
            <Globe size={13} /> {lang === "bn" ? "EN" : "বাং"}
          </button>
          {user ? (
            <>
              <span className="lp-user"><b>{user.name}</b><small>{t.logged_in_as} {user.role}</small></span>
              {isStaff && <button className="lp-btn-primary" data-testid="lp-open-crm" onClick={openCrm}>{t.open_crm} <ArrowRight size={13} /></button>}
              <button className="lp-btn-ghost" data-testid="lp-logout" onClick={logout}>{t.logout}</button>
            </>
          ) : (
            <>
              <button className="lp-btn-ghost" data-testid="lp-login-open" onClick={() => openAuth("login")}><LogIn size={13} /> {t.login}</button>
              <button className="lp-btn-primary" data-testid="lp-register-open" onClick={() => openAuth("register")}>{t.register}</button>
            </>
          )}
        </div>
      </header>

      <section className="lp-hero" data-testid="lp-hero">
        <div className="lp-hero-copy">
          <p className="lp-tag">{t.hero_tagline}</p>
          <h1>{t.hero_title}</h1>
          <p className="lp-sub">{t.hero_sub}</p>
          <div className="lp-hero-ctas">
            <button className="lp-btn-primary lp-lg" data-testid="lp-hero-join" onClick={() => user ? setComplaintOpen(true) : openAuth("register")}>
              <Sparkles size={16} /> {t.cta_join}
            </button>
            <button className="lp-btn-outline lp-lg" data-testid="lp-hero-complaint" onClick={() => user ? setComplaintOpen(true) : openAuth("register")}>
              <MessageSquareWarning size={16} /> {t.cta_complaint}
            </button>
          </div>
        </div>
        <div className="lp-hero-art" aria-hidden>
          <div className="lp-orb lp-orb-1" />
          <div className="lp-orb lp-orb-2" />
          <div className="lp-orb lp-orb-3" />
          <div className="lp-hero-emblem"><Heart size={44} /></div>
        </div>
      </section>

      <section className="lp-mission" data-testid="lp-mission">
        <p className="lp-eyebrow">{t.mission_eyebrow}</p>
        <h2>{t.mission_title}</h2>
        <p className="lp-mission-body">{t.mission_body}</p>
      </section>

      <section className="lp-programs" id="programs" data-testid="lp-programs">
        <p className="lp-eyebrow">{t.programs_eyebrow}</p>
        <h2>{t.programs_title}</h2>
        <div className="lp-program-grid">
          {[
            { icon: GraduationCap, t: t.p1_title, b: t.p1_body },
            { icon: Target, t: t.p2_title, b: t.p2_body },
            { icon: Rocket, t: t.p3_title, b: t.p3_body },
            { icon: Sparkles, t: t.p4_title, b: t.p4_body },
          ].map((p, i) => (
            <div key={i} className="lp-program-card" data-testid={`lp-program-${i}`}>
              <div className="lp-program-icon"><p.icon size={22} /></div>
              <b>{p.t}</b>
              <p>{p.b}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="lp-complaint" id="complaint" data-testid="lp-complaint">
        <p className="lp-eyebrow">{t.complaint_eyebrow}</p>
        <h2>{t.complaint_title}</h2>
        <p className="lp-mission-body">{t.complaint_sub}</p>
        <button className="lp-btn-primary lp-lg" data-testid="lp-complaint-open" onClick={() => user ? setComplaintOpen(true) : openAuth("register")}>
          <MessageSquareWarning size={16} /> {t.cta_complaint}
        </button>
      </section>

      <section className="lp-advice" id="advice" data-testid="lp-advice">
        <p className="lp-eyebrow">{t.advice_eyebrow}</p>
        <h2>{t.advice_title}</h2>
        {(() => {
          const CATS = [
            { id: "all", label: t.cat_all },
            { id: "student", label: t.cat_student },
            { id: "career", label: t.cat_career },
            { id: "exam", label: t.cat_exam },
            { id: "entrepreneur", label: t.cat_entrepreneur },
          ];
          const norm = (s) => (s || "").toString().toLowerCase().trim();
          const countFor = (id) =>
            id === "all"
              ? advice.length
              : advice.filter((p) => (p.tags || []).some((tg) => norm(tg) === id)).length;
          const filtered =
            activeCategory === "all"
              ? advice
              : advice.filter((p) => (p.tags || []).some((tg) => norm(tg) === activeCategory));
          return (
            <>
              {advice.length > 0 && (
                <div className="lp-cat-strip" data-testid="lp-cat-strip">
                  {CATS.map((c) => (
                    <button
                      key={c.id}
                      className={`lp-cat-chip ${activeCategory === c.id ? "on" : ""}`}
                      data-testid={`lp-cat-${c.id}`}
                      onClick={() => setActiveCategory(c.id)}
                    >
                      {c.label} <em>{countFor(c.id)}</em>
                    </button>
                  ))}
                </div>
              )}
              {filtered.length === 0 ? (
                <p className="lp-mission-body">{t.advice_none}</p>
              ) : (
                <div className="lp-advice-grid" data-testid="lp-advice-grid">
                  {filtered.map((p) => {
                    const title = (lang === "bn" ? p.title_bn : p.title_en) || p.title_en || p.title_bn;
                    const body = (lang === "bn" ? p.body_bn : p.body_en) || p.body_en || p.body_bn;
                    return (
                      <article key={p.post_id} className="lp-advice-card" data-testid={`lp-advice-${p.post_id}`}>
                        {p.cover_image && <img src={p.cover_image} alt={title} className="lp-advice-cover" />}
                        <div className="lp-advice-body">
                          <div className="lp-advice-tags">
                            {(p.tags || []).slice(0, 3).map((tg) => <span key={tg} className="lp-advice-tag">{tg}</span>)}
                          </div>
                          <b>{title}</b>
                          <p>{(body || "").slice(0, 160)}{body && body.length > 160 ? "…" : ""}</p>
                          <div className="lp-advice-foot">
                            <small>{p.author_name}</small>
                            <div className="lp-advice-actions">
                              <button className="lp-advice-like" data-testid={`lp-advice-react-${p.post_id}`} onClick={() => react(p)}>
                                <Heart size={12} fill={p.my_reaction ? "#ea823f" : "none"} /> {p.reactions || 0}
                              </button>
                              <button className="lp-advice-read" data-testid={`lp-advice-open-${p.post_id}`} onClick={() => setReadingPost(p)}>
                                <BookOpen size={12} /> {t.advice_read}
                              </button>
                            </div>
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>
              )}
            </>
          );
        })()}
      </section>

      {user && myComplaints.length > 0 && (
        <section className="lp-tracker" id="my-complaints" data-testid="lp-tracker">
          <p className="lp-eyebrow">{t.my_complaints_eyebrow}</p>
          <h2>{t.my_complaints_title}</h2>
          <div className="lp-tracker-list" data-testid="lp-tracker-list">
            {myComplaints.map((c) => (
              <div key={c.complaint_id} className={`lp-tracker-row lp-status-${(c.status || "").toLowerCase().replace(/\s+/g, "-")}`} data-testid={`lp-tracker-${c.complaint_id}`}>
                <div className="lp-tracker-body">
                  <b>{c.title}</b>
                  <small>{c.complaint_id} · Booth {c.booth} · {new Date(c.created_at).toLocaleDateString()}</small>
                  {c.description && <p>{c.description.slice(0, 120)}</p>}
                </div>
                <div className="lp-tracker-status">
                  {c.status === "Solved" || c.status === "Closed"
                    ? <CheckCircle2 size={14} />
                    : <Clock size={14} />}
                  <b>{c.status}</b>
                  <small>{c.assignee !== "Unassigned" ? c.assignee : ""}</small>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="lp-testimonials" data-testid="lp-testimonials">
        <p className="lp-eyebrow">{t.testi_eyebrow}</p>
        <h2>{t.testi_title}</h2>
        <div className="lp-testi-grid">
          {t.testimonials.map((tt, i) => (
            <blockquote key={i} className="lp-testi-card" data-testid={`lp-testi-${i}`}>
              <Quote size={20} />
              <p>{tt.quote}</p>
              <footer><b>{tt.name}</b><small>{tt.role}</small></footer>
            </blockquote>
          ))}
        </div>
      </section>

      <section className="lp-contact" id="contact" data-testid="lp-contact">
        <p className="lp-eyebrow">{t.contact_eyebrow}</p>
        <h2>{t.contact_title}</h2>
        <p className="lp-mission-body">{t.contact_sub}</p>
        <div className="lp-contact-cta">
          {!user && <button className="lp-btn-primary lp-lg" data-testid="lp-contact-join" onClick={() => openAuth("register")}>{t.register}</button>}
        </div>
      </section>

      <footer className="lp-footer">{t.footer}</footer>

      {/* Auth modal */}
      {authOpen && (
        <div className="lp-modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget) closeAuth(); }}>
          <form className="lp-modal" data-testid="lp-auth-modal" onSubmit={submitAuth}>
            <div className="lp-modal-head">
              <b>{authMode === "register" ? t.register_title : t.login_title}</b>
              <button type="button" className="lp-icon-btn" onClick={closeAuth}><X size={14} /></button>
            </div>
            {authMode === "register" && (
              <>
                <label>{t.name_lbl}<input required data-testid="lp-auth-name" value={authForm.name} onChange={(e) => setAuthForm({ ...authForm, name: e.target.value })} /></label>
                <label>{t.mobile_lbl}<input required data-testid="lp-auth-mobile" value={authForm.mobile} onChange={(e) => setAuthForm({ ...authForm, mobile: e.target.value })} /></label>
              </>
            )}
            <label>{t.email}<input type="email" required data-testid="lp-auth-email" value={authForm.email} onChange={(e) => setAuthForm({ ...authForm, email: e.target.value })} /></label>
            <label>{t.password}<input type="password" required minLength={6} data-testid="lp-auth-password" value={authForm.password} onChange={(e) => setAuthForm({ ...authForm, password: e.target.value })} /></label>
            {authErr && <p className="lp-err" data-testid="lp-auth-err">{authErr}</p>}
            <button type="submit" className="lp-btn-primary lp-lg" data-testid="lp-auth-submit" disabled={authBusy}>{authBusy ? "…" : (authMode === "register" ? t.submit_register : t.submit_login)}</button>
            <div className="lp-modal-toggle">
              {authMode === "register" ? (
                <><span>{t.have_account}</span><button type="button" data-testid="lp-auth-switch-login" onClick={() => setAuthMode("login")}>{t.login}</button></>
              ) : (
                <><span>{t.no_account}</span><button type="button" data-testid="lp-auth-switch-register" onClick={() => setAuthMode("register")}>{t.register}</button></>
              )}
            </div>
          </form>
        </div>
      )}

      {/* Public complaint modal */}
      {complaintOpen && (
        <div className="lp-modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget) { setComplaintOpen(false); setComplaintResult(null); } }}>
          <form className="lp-modal" data-testid="lp-complaint-modal" onSubmit={lodgeComplaint}>
            <div className="lp-modal-head">
              <b>{t.cta_complaint}</b>
              <button type="button" className="lp-icon-btn" onClick={() => { setComplaintOpen(false); setComplaintResult(null); }}><X size={14} /></button>
            </div>
            {complaintResult ? (
              <div className="lp-complaint-success" data-testid="lp-complaint-success">
                <Sparkles size={22} />
                <b>{complaintResult.complaint_id}</b>
                <p>{lang === "bn" ? "আপনার অভিযোগ গৃহীত হয়েছে। বুথ-দায়িত্বপ্রাপ্ত সদস্যকে অবগত করা হয়েছে।" : "Your complaint was logged and the booth-responsible member has been alerted."}</p>
                <button type="button" className="lp-btn-primary" onClick={() => { setComplaintOpen(false); setComplaintResult(null); }}>OK</button>
              </div>
            ) : (
              <>
                <label>{t.complaint_title_lbl}<input required data-testid="lp-complaint-title" value={complaintForm.title} onChange={(e) => setComplaintForm({ ...complaintForm, title: e.target.value })} /></label>
                <label>{t.complaint_desc_lbl}<textarea rows={3} data-testid="lp-complaint-desc" value={complaintForm.description} onChange={(e) => setComplaintForm({ ...complaintForm, description: e.target.value })} /></label>
                <label>{t.complaint_booth_lbl}<input data-testid="lp-complaint-booth" value={complaintForm.booth} onChange={(e) => setComplaintForm({ ...complaintForm, booth: e.target.value })} /></label>
                <button type="submit" className="lp-btn-primary lp-lg" data-testid="lp-complaint-submit" disabled={complaintBusy}>
                  <Send size={14} /> {complaintBusy ? "…" : t.complaint_send}
                </button>
              </>
            )}
          </form>
        </div>
      )}
      {/* Advice read modal */}
      {readingPost && (
        <div className="lp-modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget) setReadingPost(null); }}>
          <div className="lp-modal lp-modal-read" data-testid="lp-advice-read-modal">
            <div className="lp-modal-head">
              <b>{(lang === "bn" ? readingPost.title_bn : readingPost.title_en) || readingPost.title_en || readingPost.title_bn}</b>
              <button className="lp-icon-btn" onClick={() => setReadingPost(null)}><X size={14} /></button>
            </div>
            <div className="lp-read-meta"><small>{readingPost.author_name} · {readingPost.author_role}</small></div>
            <div className="lp-read-body">{(lang === "bn" ? readingPost.body_bn : readingPost.body_en) || readingPost.body_en || readingPost.body_bn}</div>
            <div className="lp-read-actions">
              <button className="lp-advice-like" data-testid="lp-advice-modal-react" onClick={() => react(readingPost)}>
                <Heart size={13} fill={readingPost.my_reaction ? "#ea823f" : "none"} /> {readingPost.reactions || 0} {readingPost.my_reaction ? t.advice_liked : t.advice_like}
              </button>
            </div>

            {/* Comments */}
            <div className="lp-comments" data-testid="lp-comments">
              <div className="lp-comments-head">
                <MessageCircle size={14} />
                <b>{t.comments_title}</b>
                <em>{comments.filter((c) => !c.hidden).length}</em>
              </div>

              {user ? (
                <form className="lp-comment-composer" data-testid="lp-comment-composer" onSubmit={submitComment}>
                  <textarea
                    data-testid="lp-comment-input"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value.slice(0, 280))}
                    placeholder={t.comment_placeholder}
                    rows={2}
                    maxLength={280}
                  />
                  <div className="lp-comment-actions">
                    <small>{commentText.length}/280 · {lang.toUpperCase()}</small>
                    <button type="submit" className="lp-btn-primary" data-testid="lp-comment-submit" disabled={commentBusy || !commentText.trim()}>
                      <Send size={12} /> {commentBusy ? "…" : t.comment_send}
                    </button>
                  </div>
                </form>
              ) : (
                <button className="lp-btn-outline" data-testid="lp-comment-login" onClick={() => openAuth("login")}>
                  <LogIn size={12} /> {t.comment_login_prompt}
                </button>
              )}

              {comments.length === 0 ? (
                <p className="lp-comments-empty" data-testid="lp-comments-empty">{t.comments_none}</p>
              ) : (
                <ul className="lp-comment-list" data-testid="lp-comment-list">
                  {comments.map((c) => (
                    <li
                      key={c.comment_id}
                      className={`lp-comment ${c.hidden ? "lp-comment-hidden" : ""}`}
                      data-testid={`lp-comment-${c.comment_id}`}
                    >
                      <div className="lp-comment-head">
                        <b>{c.user_name}</b>
                        <small>{new Date(c.created_at).toLocaleString()} · {c.language?.toUpperCase()}</small>
                        {c.hidden && <span className="lp-comment-tag">{t.comment_hidden}</span>}
                      </div>
                      <p>{c.text}</p>
                      {user?.role === "Super Admin" && (
                        <button
                          className="lp-comment-mod"
                          data-testid={`lp-comment-mod-${c.comment_id}`}
                          onClick={() => toggleHideComment(c)}
                        >
                          {c.hidden ? <><Eye size={11} /> {t.comment_unhide}</> : <><EyeOff size={11} /> {t.comment_hide}</>}
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
